import { render, staticRenderFns } from "./PropertyChooser.vue?vue&type=template&id=b324953e&scoped=true"
import script from "./PropertyChooser.vue?vue&type=script&lang=js"
export * from "./PropertyChooser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b324953e",
  null
  
)

export default component.exports